import { UtilitarioService } from "@app/services/utilitario.service";

export class FiltrosPagasPagar {
  UnidadeId: number[];
  ContaId: number;
  ParticipanteId: number;
  TipoData: 'Vencimento' | 'Emissao' | 'Pagamento';
  DataInicial: string;
  DataFinal: string;
  ProcessoId: number;
  Observacao: string;
  Liberados: 'SIM' | 'NÃO';

  constructor() {
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(0);
    this.Liberados = 'SIM';
  }

}
